// ABOUTME: Global error boundary for unhandled server-side errors
// ABOUTME: Shows a user-friendly error page; reports the error to PostHog

"use client"

import { useEffect } from "react"
import posthog from "posthog-js"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // PostHog auto-captures unhandled errors via window.onerror, but a
    // React rendering error caught by this boundary doesn't reach that
    // listener. Capture explicitly so the "this has been logged" copy
    // below is actually true.
    if (process.env.NODE_ENV === "production" && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.captureException(error, {
        digest: error.digest,
        boundary: "global-error",
      })
    }
  }, [error])

  return (
    <html>
      <body>
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
          backgroundColor: "#fafafa",
        }}>
          <div style={{ textAlign: "center", maxWidth: "400px", padding: "2rem" }}>
            <h1 style={{ fontSize: "1.5rem", fontWeight: 600, color: "#111", marginBottom: "0.5rem" }}>
              Something went wrong
            </h1>
            <p style={{ color: "#666", fontSize: "0.875rem", marginBottom: "1.5rem" }}>
              We hit an unexpected error. This has been logged and we&apos;re looking into it.
            </p>
            <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
              <button
                onClick={reset}
                style={{
                  padding: "0.5rem 1.25rem",
                  backgroundColor: "#111",
                  color: "#fff",
                  border: "none",
                  borderRadius: "0.5rem",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                Try again
              </button>
              {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
              <a
                href="/"
                style={{
                  padding: "0.5rem 1.25rem",
                  backgroundColor: "#fff",
                  color: "#111",
                  border: "1px solid #ddd",
                  borderRadius: "0.5rem",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  textDecoration: "none",
                }}
              >
                Go home
              </a>
            </div>
            {error.digest && (
              <p style={{ color: "#999", fontSize: "0.75rem", marginTop: "1.5rem" }}>
                Error ID: {error.digest}
              </p>
            )}
          </div>
        </div>
      </body>
    </html>
  )
}
